import {
  CREATE_TOKEN_REQUESTED,
  CREATE_TOKEN_SUCCESS,
  CREATE_TOKEN_FAILURE,
  GET_TOKENS_REQUESTED,
  GET_TOKENS_FAILURE,
  GET_TOKENS_SUCCESS,
  DELETE_TOKEN_REQUESTED,
  DELETE_TOKEN_FAILURE,
  DELETE_TOKEN_SUCCESS,
} from '../actions';

const initialState = {
  apitokens: [],
  isLoading: false,
  isSaving: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TOKENS_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };

    case GET_TOKENS_SUCCESS:
      return {
        ...state,
        apitokens: action.payload.results,
        isLoading: false,
      };

    case GET_TOKENS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case CREATE_TOKEN_REQUESTED:
    case DELETE_TOKEN_REQUESTED:
      return {
        ...state,
        isSaving: true,
      };

    case CREATE_TOKEN_SUCCESS:
      return {
        ...state,
        apitokens: [...state.apitokens, action.payload],
        isSaving: false,
      };

    case DELETE_TOKEN_SUCCESS: {
      const index = state.apitokens.map((item) => item.id).indexOf(action.meta.id);
      const newTokenArray = [
        ...state.apitokens.slice(0, index),
        ...state.apitokens.slice(index + 1),
      ];
      return {
        ...state,
        apitokens: newTokenArray,
        isSaving: false,
      };
    }

    case CREATE_TOKEN_FAILURE:
    case DELETE_TOKEN_FAILURE:
      return {
        ...state,
        isSaving: false,
      };

    default:
      return state;
  }
};
